<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ this.category.id === null ? "ADICIONAR NOVO" : "ATUALIZAR" }} CADERNO</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >

      <div class="p-6">
        <!-- NAME -->
        <vs-input
          label="Nome"
          v-model="category.name"
          class="mt-5 w-full"
          name="Nome"
          v-validate="this.category.id === null ? 'required' : ''"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Nome')"
        >
          {{ errors.first('Nome') }}
        </span>

        <div style="clear: both;" />

        <div class="mt-5 mb-8">
          <label class="vs-input--label">Descrição</label>

          <vs-textarea 
            :counter="200"
            :counter-danger.sync="counterDanger"
            v-model="category.description"
            class="w-full"
            name="Descrição"
            v-validate="this.category.id === null ? 'required|max:200' : 'max:200'"
          />

          <span
            class="text-danger text-sm"
            v-show="errors.has('Descrição')"
          >
            {{ errors.first('Descrição') }}
          </span>
        </div>

        <div style="clear: both;" />

        <!-- Image -->
        <vs-input
          type="file"
          label="Imagem Representativa do Caderno"
          @change="uploadImage"
          class="mt-5 mb-5 w-full"
          accept="image/jpeg, image/png"
        />

        <p v-if="errorMessage !== ''" class="text-danger text-sm">
          {{ errorMessage }}
        </p>

        <div v-if="category.image_url" style="display: flex; flex-direction: row; align-items: center;">
          <img :src="category.image_url" style="max-height: 80px; max-width: 100%; margin-right: 15px;" />
          <a :href="category.image_url" target="_blank">Ver Imagem</a>
        </div>

        <vs-input
          v-model="category.image_url"
          class="mt-1 w-full"
          name="imagem"
          :v-validate="this.category.id === null ? 'required' : ''"
          hidden
          readonly
        />

        <div class="mt-5 custom-control custom-checkbox">
          <vs-checkbox
            v-model="category.activated"
            class="custom-control-label"
            name="activated"
            v-if="this.category.id"
          >
            Ativo
          </vs-checkbox>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">
        Salvar
      </vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">
        Cancelar
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import fileHttp from '@/http/requests/file'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'category-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    category: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          name: '',
          slug: '',
          activated: true,
          image_url: null,
          description: null
        }
      }
    }
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60
      },
      categoryData: {},
      errorMessage: '',
      counterDanger: false
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    }
  },
  watch: {
    'category.id'() {
      this.errorMessage = ''
      
      if (this.category.id && !this.category.image_url) {
        this.errorMessage = 'A imagem representativa do caderno é obrigatória!'
      }
    }
  },
  methods: {
    initValues() {
      this.categoryData = this.$_.cloneDeep(this.category);
    },
    uploadImage(e) {
      const files = e.target.files

      if(files.length) {
        const file = files[0]
        fileHttp.upload(file).then(res => {
          const uploadedImage = res.data;
          
          if (!uploadedImage.success) {
            this.errorMessage = uploadedImage.message
            return false
          }

          this.removePreviousImage()
            .then(() => {
              this.errorMessage = ''
              this.category.image_url = uploadedImage.fileUrl
            }).catch(err => {
              console.error(err)
            })
        }).catch(err => {
          console.error(err)
        })
      }
    },
    removePreviousImage() {
      return new Promise((resolve, reject) => {
        const fileUrl = this.category.image_url;

        if (fileUrl) {
          const urlArray = fileUrl.split("/");
          const filename = urlArray[urlArray.length - 1]

          fileHttp
          .delete(filename)
          .then(() => { return resolve({}) })
          .catch(err => { return reject(err) })
        }

        return resolve({})
      })
    },
    submitData() {
      const that = this
      
      if (!this.category.image_url) {
        this.errorMessage = 'A imagem representativa do caderno é obrigatória!'
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.category.id !== null && this.category.id >= 0) {
            this.$store.dispatch("category/update", this.category).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
            }).catch(err => {
              console.error(err)
            })
          } else {
            delete this.category.id
            this.$store.dispatch("category/add", this.category).then(() => {
              that.initValues()
              this.$emit('closeSidebar')
            }).catch(err => {
              console.error(err)
            })
          }
        }
      })
    }
  },
  components: {
    VuePerfectScrollbar
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
